import React from 'react';

import { SxProps, Theme } from '@mui/material';

import Drawer from 'components/Drawer';

import ImportIcon from 'components/icons/ImportIcon';
import AuthorizedComponent from 'components/AuthorizedComponent';

type Props = React.PropsWithChildren<
	{
		className?: string;
		title: string;
		onImport?: () => any;
		goBack?: boolean;
		sx?: SxProps<Theme>;
	} & Omit<AuthorizedComponentProps, 'component'>
>;

function ScreenContainer({ children, className, title, onImport, goBack, sx, ...authorizationProps }: Props) {
	return (
		<Drawer title={title} goBack={goBack}>
			<div id="test-0" className={className}>
				{!!onImport && (
					<AuthorizedComponent {...authorizationProps}>
						<ImportIcon onImport={onImport} />
					</AuthorizedComponent>
				)}
				{children}
			</div>
		</Drawer>
	);
}

export default ScreenContainer;
